import config from 'constants/config'

let cachedExperienceId: string | undefined
let cachedExperienceIds: Set<string> | undefined
let cachedTicketIds: Set<string> | undefined

export function getLoyaltyTransferExperienceId(): string {
  if (cachedExperienceId === undefined) {
    cachedExperienceId = config.LOYALTY_TRANSFER_CONFIG.loyaltyTransfer.experienceId
  }
  return cachedExperienceId
}

export function getMagicLoyaltyTransferExperienceIds(): Set<string> {
  if (cachedExperienceIds === undefined) {
    const { ultraLux, loyaltyTransfer } = config.LOYALTY_TRANSFER_CONFIG
    cachedExperienceIds = new Set([ultraLux.experienceId, loyaltyTransfer.experienceId])
  }
  return cachedExperienceIds
}

export function getMagicLoyaltyTransferExperienceTicketIds(): Set<string> {
  if (cachedTicketIds === undefined) {
    const { ultraLux, loyaltyTransfer } = config.LOYALTY_TRANSFER_CONFIG
    cachedTicketIds = new Set([ultraLux.ticketId, loyaltyTransfer.ticketId])
  }
  return cachedTicketIds
}
